import useHttp from 'helpers/HttpMethods';
import { ArticlePaginated } from 'types/ArticleTypes';
import { PaginatedContactSummary } from 'types/CustomerContactsTypes';
import { GlobalSearch, GlobalSearchInput } from 'types/GlobalSearchTypes';
import { PaginatedTicketSummary } from 'types/TicketTypes';

const http = useHttp();
class GlobalSearchService {
  static async search(body: GlobalSearchInput): Promise<GlobalSearch> {
    return await http.post(body, '/search');
  }

  static async searchTickets(
    body: GlobalSearchInput
  ): Promise<PaginatedTicketSummary> {
    return await http.post(body, '/search/tickets');
  }

  static async searchContacts(
    body: GlobalSearchInput
  ): Promise<PaginatedContactSummary> {
    return await http.post(body, '/search/contacts');
  }

  static async searchArticles(
    body: GlobalSearchInput
  ): Promise<ArticlePaginated> {
    return await http.post(body, '/search/articles');
  }
}

export default GlobalSearchService;
